export enum CONFLICT_MODAL_STATE {
    DEFAULT = 'default',
    CANCEL = 'cancel',
    KEEP = 'keep',
    CONFLICT_NOT_CANCELABLE = 'conflictNotCancelable'
}

export enum CONFLICT_MODAL_DESICION {
    DEFAULT,
    CANCEL,
    KEEP
}
